import React, { useState, useEffect } from 'react';
import InputGroup from './ui/InputGroup';
import ResultCard from './ui/ResultCard';
import ToggleGroup from './ui/ToggleGroup';

const CostCalculator = () => {
  const [bagPrice, setBagPrice] = useState(18.00);
  const [bagWeight, setBagWeight] = useState(12);
  const [weightUnit, setWeightUnit] = useState('oz');
  const [strength, setStrength] = useState('standard');

  const [costPerCup, setCostPerCup] = useState(0);
  const [costPerPot, setCostPerPot] = useState(0);

  useEffect(() => {
    const weightInOz = weightUnit === 'lbs' ? bagWeight * 16 : bagWeight;
    const costPerOz = bagPrice / weightInOz;
    
    // Math based on user's 96oz pot baseline
    const ozPerFlOz = strength === 'standard' ? (1.5 / 96) : (2.0 / 96);
    
    // Cost for one 96oz pot
    const coffeePer96PotOz = 96 * ozPerFlOz;
    const potCost = coffeePer96PotOz * costPerOz;
    
    // Cost for one 8oz cup (1/12th of a 96oz pot)
    const cupCost = potCost / 12;

    setCostPerCup(cupCost.toFixed(2));
    setCostPerPot(potCost.toFixed(2));
  }, [bagPrice, bagWeight, weightUnit, strength]);

  return (
    <div className="space-y-8 animate-fade-in">
      <div>
        <h2 className="text-2xl font-bold text-white mb-2">Cost Analyzer</h2>
        <p className="text-slate-400">Demonstrate the value of Bat Coffee bags by showing cost-per-serving.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="space-y-6">
          <InputGroup
            label="Price per Bag"
            id="bagPrice"
            value={bagPrice}
            onChange={(e) => setBagPrice(Number(e.target.value))}
            unit="$"
            min="1"
            step="0.5"
          />
          <div className="grid grid-cols-2 gap-3">
            <InputGroup
              label="Bag Weight"
              id="bagWeight"
              value={bagWeight}
              onChange={(e) => setBagWeight(Number(e.target.value))}
              min="0.1"
            />
            <ToggleGroup
              label="Unit"
              activeValue={weightUnit}
              onChange={setWeightUnit}
              options={[
                { label: 'Lbs', value: 'lbs' },
                { label: 'Oz', value: 'oz' },
              ]}
            />
          </div>
        </div>
        <div className="space-y-6">
          <ToggleGroup
            label="Yield Strength"
            activeValue={strength}
            onChange={setStrength}
            options={[
              { label: 'Standard (1.5oz)', value: 'standard' },
              { label: 'Bold (2.0oz)', value: 'bold' },
            ]}
          />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-8">
        <ResultCard title="Cost per 8oz Cup" value={`$${costPerCup}`} highlight={true} />
        <ResultCard title="Cost per 96oz Pot" value={`$${costPerPot}`} />
      </div>
    </div>
  );
};

export default CostCalculator;